module.exports = function getResource(label, vars = []) {
    let resources = {
        pickUpInStore: 'Pick Up In Store',
        chooseThisStore: 'Choose This Store',
        notAbleToFind: `We were not able to find a store near “${vars[0]}”.`,
        differentLocation: 'Please try a different location.',
        ok: 'OK',
        changeStoreTitle: 'Change Store',
        changeStoreMessage: 'If there are any pickup items in your basket, the pickup location will also be updated to',
        anyPromosRewardsMsg: 'Any promos or rewards in your pickup basket will also be removed. You may add promos and rewards in store, if available.'
    };

    return resources[label];
};
